import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, CardView, rem, Spacer } from 'design-system';
import IconGraph from 'design-system/icons/IconGraph';
import Section from 'design-system/Section';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { selectIsEnabledTradingAccountActive } from 'features/invest/reducers/selectors';
import { selectIsGBUser } from 'reducers/selectors';
import createStyleSheets from 'utils/createStyleSheets';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../constants';
const OpenInvestAccountCTA = ({ withTopSpacing }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { navigateToTab } = useTabNavigation();
    const isUserGB = useAppSelector(selectIsGBUser);
    const isInvestAccountActive = useAppSelector(selectIsEnabledTradingAccountActive);
    const handleOInvestCTAPress = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://invest/account', 'Set up investment account');
            return;
        }
        navigateToTab('Invest');
    }, [navigateToTab]);
    if (isInvestAccountActive || !isUserGB)
        return null;
    return (<Section title="Grow your money with Emma" style={[styles.section, withTopSpacing && styles.topSpacing]}>
      <CardView noMarginTop noMarginBottom withPadding>
        <Squircle width={rem(44)} height={rem(44)} color={colors.background.dark}>
          <IconGraph gradientKey="pro"/>
        </Squircle>
        <Spacer.H16 />
        <Text Text-16>Start investing</Text>
        <Spacer h={4}/>
        <Text TextThin-14 Secondary>
          Invest in globally diversified ETFs and funds. Capital at Risk.
        </Text>
        <Spacer.H16 />
        <View style={styles.row}>
          <Button hug brandReversed square small title="Set up investment account" onPress={handleOInvestCTAPress}/>
        </View>
      </CardView>
    </Section>);
};
export default memo(OpenInvestAccountCTA);
const styleSet = createStyleSheets(() => ({
    row: {
        flexDirection: 'row',
    },
    section: {
        marginTop: rem(8),
    },
    topSpacing: {
        marginTop: rem(24),
    },
}));
